<app-sliding-window [toggleWindow]="showCommentWindow$ | async" [contentPaddingRem]="0">
  <div header>
    <app-sliding-window-header
      [slidingWindowOptions]="commentWindowOptions$ | async"
      (closeButtonClicked)="toggleCommentWindow()" />
    <div class="header-content" *ngIf="headerText">
      {{ headerText }}
    </div>
  </div>
  <div content>
    <app-comments-form
      #form
      [headerHeight]="!!headerText ? '5rem' : '0rem'"
      [comments]="comments"
      [isLoading]="isLoading"
      [dropdownItems]="dropdownItems"
      (filterText)="filterText.emit($event)"
      (commentValueChanged)="onCommentValueChange($event)"
      (newComment)="newComment.emit($event)" />
  </div>
  <app-sliding-window-footer
    footer
    [hideActionButton]="hideActionButton$ | async"
    [slidingWindowOptions]="commentWindowOptions$ | async"
    (primaryButtonClicked)="form.submitForm()"
    (secondaryButtonClicked)="toggleCommentWindow()" />
</app-sliding-window>

<button
  type="button"
  [style.margin-bottom.rem]="buttonMarginBottomRem"
  class="comment-button"
  [ngClass]="{
    'unread-comments-button': (hasUnreadComments$ | async),
    'no-unread-comments-button': !(hasUnreadComments$ | async)
  }"
  (click)="toggleCommentWindow()">
  <div class="d-flex flex-column align-items-center">
    <img [src]="commentButtonIconSrc$ | async" class="bubble" alt="Comments" i18n-alt />
    <img *ngIf="hasUnreadComments$ | async" class="indicator" src="assets/icons/white/Indicator.svg" />
  </div>
</button>
